import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ClipboardListIcon, FootprintsIcon, MoveDiagonalIcon, Rows3Icon, ScaleIcon, ZapIcon } from 'lucide-react';
import { Pill } from './Pill';
import { volumes } from '../data/volumes';
const icons = [FootprintsIcon, Rows3Icon, ScaleIcon, MoveDiagonalIcon, ZapIcon, ClipboardListIcon];
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="volumes-heading" id="volumes" data-id="element-166" data-mp="3g2vaxdry98qx">
      <div className="mx-auto max-w-3xl px-6" data-id="element-167" data-mp="3pv124ladnm52">
        <div className="text-center" data-id="element-168" data-mp="3pvsza0jmhrxg">
          <Pill data-id="element-169" data-mp="3pwvp0557lobs">The library</Pill>
          <h2 id="volumes-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-170" data-mp="3l3srjlxb9uqb">
            6 Complete Master Volumes
          </h2>
          <p className="mx-auto mt-3 max-w-xl font-sans text-sm leading-relaxed text-ash" data-id="element-171" data-mp="2xcdnnopvz5cy">
            Tap any volume to see what’s inside.
          </p>
        </div>

        <ol className="mt-9 space-y-3" data-id="element-172" data-mp="29ez5g1hdyq2v">
          {volumes.map((volume, index) => {
          const Icon = icons[index];
          const isOpen = openIndex === index;
          return <li key={volume.number} data-id="element-173" data-mp="2j51yu2sf661q" data-mpi={index}>
                <div className={`rounded-2xl border transition-colors duration-150 ease-out ${isOpen ? 'border-gold/60 bg-blush' : 'border-rose-deep/20 bg-white hover:border-rose-deep/50'}`} data-id="element-174" data-mp="2j7enszwlhgoa">
                  <h3 data-id="element-175" data-mp="1qih3yscqjbtf">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-start gap-4 rounded-2xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wine" data-id="element-176" data-mp="1qiz788xteqau">
                      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-wine text-cream' : 'bg-rose-light text-wine'}`} aria-hidden="true" data-id="element-177" data-mp="3buqxi9hnpu06">
                        <Icon className="h-4 w-4" strokeWidth={1.7} data-id="element-178" data-mp="1gp9h35zd1qxo" />
                      </span>
                      <span className="min-w-0" data-id="element-179" data-mp="1br7w2fidjhjk">
                        <span className="block font-display text-xl leading-snug text-charcoal" data-id="element-180" data-mp="1pr8yhzeaex15">
                          <span className="text-rose-deep" data-id="element-181" data-mp="1ksnzu4eoolet">
                            V{Number(volume.number)}.
                          </span>{' '}
                          {volume.title}
                        </span>
                        <span className="mt-1 block font-sans text-[0.85rem] leading-relaxed text-ash" data-id="element-182" data-mp="t29pgi5vpr7w">
                          {volume.summary}
                        </span>
                      </span>
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-183" data-mp="1203mxwfdqqwn">
                    {isOpen ? <motion.div id={`volume-panel-${index}`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-184" data-mp="earckt8bgcsr">
                        <ul className="grid gap-x-8 gap-y-2 border-t border-gold/30 px-5 py-4 sm:grid-cols-2" data-id="element-185" data-mp="2h02dyvbhxpuj">
                          {volume.contents.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.85rem] leading-relaxed text-charcoal/80" data-id="element-186" data-mp="34mh7fxv3zj7k">
                              <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-187" data-mp="2uqnyspkig9v2" />
                              {item}
                            </li>)}
                        </ul>
                      </motion.div> : null}
                  </AnimatePresence>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}